/**
 * @fileoverview Module for `src/index.js`.
 */

import ReactDOM from 'react-dom';

import './lib/i18n';

import App from './App';
import { init } from './lib/Tracker';
import { initLogger } from './lib/logger';

/**
 * Bootstraps client-side tracking, logging, and React app mount.
 */
init();
initLogger();

ReactDOM.render(
  <App />,
  document.getElementById('root'),
);
